// Client-side search on the Order History page: filters the already
// server-rendered order cards by order number or phone as the shopper
// types, no reload needed since a customer's own order list is small.

document.addEventListener('input', function (event) {
  var input = event.target.closest('.js-order-search')
  if (!input) return

  var query = input.value.trim().toLowerCase()
  var list = input.closest('.addr-tab-panel').querySelector('.js-order-search-list')
  if (!list) return

  list.querySelectorAll('.order-row-card').forEach(function (card) {
    card.hidden = query.length > 0 && card.dataset.searchText.indexOf(query) === -1
  })
})
